// File: src/pages/Funil/PainelFunil.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import EmojiPicker from "emoji-picker-react";
import "./PainelFunil.css";

const API_BASE = "https://welaunchyou.com.br/crm-wly/api/funil";

// Ícones simples (opcional)
function IconPencil({ size=16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 0 0 0-1.42L18.37 3.29a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.83z"/>
    </svg>
  );
}
function IconCopy({ size=16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M16 1H4a2 2 0 0 0-2 2v12h2V3h12V1zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H8V7h11v14z"/>
    </svg>
  );
}

export default function PainelFunil() {
  const [loading, setLoading] = useState(false);
  const [funis, setFunis] = useState([]);
  const [selectedFunil, setSelectedFunil] = useState(0);
  const [statusFilter, setStatusFilter] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const [items, setItems] = useState([]);
  const [resumo, setResumo] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [total, setTotal] = useState(0);

  const [showEtapasModal, setShowEtapasModal] = useState(false);
  const [showFunilModal, setShowFunilModal] = useState(false);

  const [leadIdForm, setLeadIdForm] = useState("");
  const [leadDisplay, setLeadDisplay] = useState("");
  const [etapaIdForm, setEtapaIdForm] = useState(0);

  const [funilForm, setFunilForm] = useState({ acao: "criar", funil_id: 0, nome: "", descricao: "" });
  const [etapaForm, setEtapaForm] = useState({ acao: "criar", etapa_id: 0, funil_id: 0, nome: "", mensagem: "", dias_apos: 0, ativo: 1 });
  const [etapasOrdemDraft, setEtapasOrdemDraft] = useState([]);

  const dragItemRef = useRef(null);

  const [showBulkModal, setShowBulkModal] = useState(false);

  // Bulk modal states
  const [bulkTags, setBulkTags] = useState([]);           // tags disponíveis
  const [bulkSelectedTags, setBulkSelectedTags] = useState([]); // ids selecionados
  const [bulkMatch, setBulkMatch] = useState("any");      // any | all
  const [bulkOnlyOut, setBulkOnlyOut] = useState(true);   // só quem ainda não está no funil
  const [bulkEtapa, setBulkEtapa] = useState(0);          // etapa inicial opcional
  const [bulkCount, setBulkCount] = useState(null);       // contagem de preview
  const [bulkLoading, setBulkLoading] = useState(false);
  const [bulkQuery, setBulkQuery] = useState("");         // filtro de nome/telefone opcional
  const [bulkCreatedFrom, setBulkCreatedFrom] = useState(""); // data de criação opcional
  const [bulkCreatedTo, setBulkCreatedTo] = useState("");
  const [bulkError, setBulkError] = useState("");
  const [bulkLeads, setBulkLeads] = useState([]);
  const [bulkPage, setBulkPage] = useState(1);
  const [bulkPerPage, setBulkPerPage] = useState(50);
  const [bulkChecked, setBulkChecked] = useState(new Set());
  const [bulkSelectAll, setBulkSelectAll] = useState(false);
  const [bulkSelectAllGlobal, setBulkSelectAllGlobal] = useState(false);
  const [bulkExcluded, setBulkExcluded] = useState(new Set()); 
  // Emoji + Anexo para mensagem da etapa
  const [showEmojiEtapa, setShowEmojiEtapa] = useState(false);
  const [uploadEtapaEmAndamento, setUploadEtapaEmAndamento] = useState(false);
  const [tipoMidiaEtapa, setTipoMidiaEtapa] = useState("");
  const [arquivoUrlEtapa, setArquivoUrlEtapa] = useState("");

  const fileEtapaRef = useRef(null);



  
  
  
const selectedCount = bulkSelectAllGlobal ? Math.max(0, (bulkCount || 0) - bulkExcluded.size)
                                          : bulkChecked.size;





// dd/mm/aaaa -> yyyy-mm-dd
function brToIso(d) {
  if (!d) return "";
  const [dd, mm, yyyy] = d.split("/");
  if (!yyyy) return d; // já pode estar ISO
  return `${yyyy}-${mm}-${dd}`;
}

function clearBulkFilters() {
  setBulkSelectedTags([]);
  setBulkMatch("any");
  setBulkOnlyOut(true);
  setBulkEtapa(0);
  setBulkQuery("");
  setBulkCreatedFrom("");
  setBulkCreatedTo("");
  setBulkLeads([]);
  setBulkCount(null);
  setBulkChecked(new Set());
  setBulkExcluded(new Set());
  setBulkSelectAll(false);
  setBulkSelectAllGlobal(false);
  setBulkPage(1);
}

  const formatarDataBrasil = (dataISO) => {
  if (!dataISO || dataISO.startsWith("0000-00-00")) return "—";
  if (dataISO.includes("/")) return dataISO;
  const [data, hora] = String(dataISO).split(" ");
  if (!data || !data.includes("-")) return "—";
  const [ano, mes, dia] = data.split("-");
  return hora ? `${dia}/${mes}/${ano} ${hora}` : `${dia}/${mes}/${ano}`;
};


//  useEffect(() => { listarFunis(); }, []);
  useEffect(() => {
    if (!selectedFunil) return;
    listar();
  }, [selectedFunil, statusFilter, query, page, perPage]);


useEffect(() => { listarFunis(); }, []);

  useEffect(() => {
    if (selectedFunil) listarEtapas(selectedFunil);
  }, [selectedFunil]);

  useEffect(() => {
  async function loadTags() {
    if (!showBulkModal) return;
    try {
      const r = await fetch(`${API_BASE}/leads_tags_list.php`, { credentials: "include" });
      const j = await r.json();
      if (Array.isArray(j.tags)) setBulkTags(j.tags);
    } catch (e) {
      console.error(e);
      setBulkTags([]);
    }
  }
  loadTags();
}, [showBulkModal]);

useEffect(() => {
  setBulkPage(1);
  setBulkChecked(new Set());
  setBulkExcluded(new Set());
  setBulkSelectAllGlobal(false);
}, [
  bulkMatch,
  bulkOnlyOut,
  bulkQuery,
  bulkCreatedFrom,
  bulkCreatedTo,
  // stringify tags p/ detectar mudanças
  JSON.stringify(bulkSelectedTags.sort())
]);


 async function previewBulk(keepSelection = false) {
  if (!selectedFunil) return;
  setBulkLoading(true);
  setBulkError("");
  setBulkLeads([]);

  // só limpa seleção se NÃO for paginação
  if (!keepSelection) {
    if (bulkSelectAllGlobal) setBulkExcluded(new Set());
    else setBulkChecked(new Set());
  }

  const payload = {
    funil_id: selectedFunil,
    tag_ids: bulkSelectedTags,
    match_mode: bulkMatch,
    only_not_in_funil: !!bulkOnlyOut,
    q: bulkQuery || "",
    created_from: brToIso(bulkCreatedFrom),
    created_to: brToIso(bulkCreatedTo),
    page: bulkPage,
    per_page: bulkPerPage
  };

  try {
    const r = await fetch(`${API_BASE}/funilwzp_bulk_preview.php`, {
      method: "POST",
      credentials: "include",
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify(payload)
    });
    const j = await safeJson(r);
    if (!j.ok) throw new Error(j.error || "Falha ao pré-visualizar");
    setBulkCount(j.count || 0);
    setBulkLeads(Array.isArray(j.leads) ? j.leads : []);
  } catch (e) {
    setBulkError(e.message || "Falha ao pré-visualizar");
  } finally {
    setBulkLoading(false);
  }
}




async function confirmBulk() {
  if (!selectedFunil) return;
  if (!window.confirm("Confirmar inclusão em massa?")) return;

  setBulkLoading(true);
  try {
    const r = await fetch(`${API_BASE}/funilwzp_bulk_add.php`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        funil_id: selectedFunil,
        tag_ids: bulkSelectedTags,
        match_mode: bulkMatch,
        only_not_in_funil: !!bulkOnlyOut,
        etapa_id: Number(bulkEtapa) || 0,
        q: bulkQuery || "",
        created_from: brToIso(bulkCreatedFrom),
        created_to: brToIso(bulkCreatedTo),

        // regra:
        // - se bulkSelectAllGlobal = true -> back usa os filtros (TODOS os candidatos)
        // - senão, se houver checkboxes marcados -> envia esses IDs
        select_all: !!bulkSelectAllGlobal,
        lead_ids: bulkSelectAllGlobal ? [] : Array.from(bulkChecked)
      })
    });
    const j = await safeJson(r);
    if (!j.ok) throw new Error(j.error || "Falha");
    alert(`Incluídos: ${j.inserted || 0} • Ignorados: ${j.skipped || 0}`);
    setShowBulkModal(false);
    listar({ preserveEtapas: true });
  } catch (e) {
    alert(e.message || "Erro");
  } finally {
    setBulkLoading(false);
  }
}


function toggleAll(val){
  setBulkSelectAll(val);
  if(val){ setBulkChecked(new Set(bulkLeads.map(l=>l.id))); }
  else { setBulkChecked(new Set()); }
}


function toggleOne(id){
  if (bulkSelectAllGlobal) {
    setBulkExcluded(prev => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });
  } else {
    setBulkChecked(prev => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });
  }
}


async function confirmBulk() {
  if (!selectedFunil) return;
  if (!window.confirm("Confirmar inclusão em massa?")) return;

  setBulkLoading(true);
  try {
    const payload = {
  funil_id: selectedFunil,
  tag_ids: bulkSelectedTags,
  match_mode: bulkMatch,
  only_not_in_funil: !!bulkOnlyOut,
  etapa_id: Number(bulkEtapa) || 0,
  q: bulkQuery || "",
  created_from: brToIso(bulkCreatedFrom),
  created_to: brToIso(bulkCreatedTo),
  select_all: !!bulkSelectAllGlobal,
  lead_ids: bulkSelectAllGlobal ? [] : Array.from(bulkChecked),
  exclude_ids: bulkSelectAllGlobal ? Array.from(bulkExcluded) : []
};
    if (bulkSelectAllGlobal) {
      payload.select_all = true;
      payload.exclude_ids = Array.from(bulkExcluded);
    } else {
      payload.select_all = false;
      payload.lead_ids = Array.from(bulkChecked);
    }

  const r = await fetch(`${API_BASE}/funilwzp_bulk_add.php`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
    const j = await safeJson(r);
    if (!j.ok) throw new Error(j.error || "Falha");
    alert(`Incluídos: ${j.inserted || 0} • Ignorados: ${j.skipped || 0}`);
    setShowBulkModal(false);
    listar({ preserveEtapas: true });
  } catch (e) {
    alert(e.message || "Erro");
  } finally {
    setBulkLoading(false);
  }
}

  async function listarFunis() {
    try {
      const r = await fetch(`${API_BASE}/funilwzp_funis_crud.php?acao=listar`, { credentials: "include" });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Erro ao listar funis");
      setFunis(j.funis || []);
      if ((j.funis || []).length && !selectedFunil) setSelectedFunil(j.funis[0].id);
    } catch (e) { console.error(e); alert("Falha ao carregar funis"); }
  }

  async function listarEtapas(funil_id) {
    try {
      const r = await fetch(`${API_BASE}/funilwzp_etapas_crud.php?acao=listar&funil_id=${funil_id}`, { credentials: "include" });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Erro ao listar etapas");
      setEtapas((j.etapas || []).map(e => ({ ...e, dias_apos: e.dias_apos ?? e.dias_após ?? 0 })));
      setEtapasOrdemDraft((j.etapas || []).map(e => e.id));
    } catch (e) { console.error(e); alert("Falha ao carregar etapas"); }
  }

  async function listar({ preserveEtapas = false } = {}) {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (selectedFunil) params.append("funil_id", selectedFunil);
      if (statusFilter) params.append("status", statusFilter);
      if (query) params.append("q", query);
      params.append("page", String(page));
      params.append("per_page", String(perPage));

      const r = await fetch(`${API_BASE}/funilwzp_listagem.php?${params.toString()}`, { credentials: "include" });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Erro ao listar leads do funil");

      setItems(j.items || []);
      setResumo(j.resumo_por_etapa || []);
      if (!preserveEtapas && j.etapas && j.etapas.length) {
        setEtapas(j.etapas.map(e => ({ ...e, dias_apos: e.dias_apos ?? e.dias_após ?? 0 })));
      }
      setTotal(j.total || 0);
    } catch (e) {
      console.error(e); alert("Falha ao carregar listagem");
    } finally { setLoading(false); }
  }

  const totalPages = useMemo(() => Math.max(1, Math.ceil(total / perPage)), [total, perPage]);
  function resumoEtapa(etapaId) {
    const r = resumo.find(x => x.etapa_id === etapaId);
    const statusCounts = r?.status_counts || {};
    const soma = Object.values(statusCounts).reduce((a, b) => a + (b || 0), 0);
    return { soma, statusCounts };
  }


function appendVar(token) {
  setEtapaForm(f => {
    const base = (f.mensagem || "").replace(/\s+$/, "");
    const sep = base.length ? " " : "";
    return { ...f, mensagem: base + sep + token };
  });
}


  async function handleAddLead(e) {
    e.preventDefault();
    if (!leadIdForm || !selectedFunil) { alert("Informe o lead e o funil"); return; }
    try {
      const payload = { lead_id: Number(leadIdForm), funil_id: Number(selectedFunil) };
      if (etapaIdForm) payload.etapa_id = Number(etapaIdForm);
      const r = await fetch(`${API_BASE}/funilwzp_add_lead.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Falha ao adicionar lead");
      alert("Lead adicionado/atualizado no funil com sucesso");
      setLeadIdForm(""); setLeadDisplay(""); setEtapaIdForm(0);
      listar();
    } catch (e) { console.error(e); alert(e.message); }
  }

  async function handlePauseResume(item, acao) {
    try {
      const r = await fetch(`${API_BASE}/funilwzp_pause_resume.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lead_id: item.lead_id, funil_id: item.funil_id, acao })
      });
      const j = await safeJson(r); if (!j.ok) throw new Error(j.error || "Falha na ação");
      listar();
    } catch (e) { alert(e.message); }
  }

  async function handleRemove(item) {
    if (!window.confirm("Remover este lead do funil?")) return;
    try {
      const r = await fetch(`${API_BASE}/funilwzp_remove_lead.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lead_id: item.lead_id, funil_id: item.funil_id })
      });
      const j = await safeJson(r); if (!j.ok) throw new Error(j.error || "Falha ao remover");
      listar();
    } catch (e) { alert(e.message); }
  }

  async function handleUpdateStage(lead_id, funil_id, etapa_id) {
    try {
      const r = await fetch(`${API_BASE}/funilwzp_update_stage.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lead_id, funil_id, etapa_id })
      });
      const j = await safeJson(r); if (!j.ok) throw new Error(j.error || "Falha ao mover de etapa");
      listar();
    } catch (e) { alert(e.message); }
  }

  function onDragStart(e, card) { dragItemRef.current = { lead_id: card.lead_id, funil_id: card.funil_id, etapa_id: card.etapa_id }; e.dataTransfer.effectAllowed = "move"; }
  function onDragOver(e) { e.preventDefault(); }
  function onDrop(e, etapaDestinoId) { e.preventDefault(); const p = dragItemRef.current; if (!p) return; if (p.etapa_id === etapaDestinoId) return; handleUpdateStage(p.lead_id, p.funil_id, etapaDestinoId); dragItemRef.current = null; }

  async function salvarFunil() {
    try {
      if ((funilForm.acao === "criar" || funilForm.acao === "editar") && !funilForm.nome) { alert("Informe o nome do funil"); return; }
      const r = await fetch(`${API_BASE}/funilwzp_funis_crud.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(funilForm)
      });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Falha no CRUD de funil");
      if (j.funil) {
        setFunis(prev => upsertById(prev, j.funil));
        if (funilForm.acao === "criar") setSelectedFunil(j.funil.id);
      } else {
        listarFunis();
      }
      alert("Salvo!");
      setFunilForm({ acao: "criar", funil_id: 0, nome: "", descricao: "" });
    } catch (e) { alert(e.message); }
  }
  function funilEditar(f) { setFunilForm({ acao: "editar", funil_id: f.id, nome: f.nome, descricao: f.descricao || "" }); }
  async function funilToggle(f) {
    const acao = f.ativo ? "desativar" : "ativar";
    try {
      const r = await fetch(`${API_BASE}/funilwzp_funis_crud.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ acao, funil_id: f.id })
      });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Falha ao alterar status");
      if (j.funil) setFunis(prev => upsertById(prev, j.funil)); else listarFunis();
    } catch (e) { alert(e.message); }
  }
  async function funilClonar(f) {
    const novo_nome = prompt("Nome do novo funil (clonado):", `${f.nome} (Cópia)`);
    if (novo_nome === null) return;
    try {
      const r = await fetch(`${API_BASE}/funilwzp_funis_crud.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ acao: "clonar", funil_id: f.id, novo_nome })
      });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Falha ao clonar");
      if (j.funil) { setFunis(prev => upsertById(prev, j.funil)); setSelectedFunil(j.funil.id); }
      else { listarFunis(); }
      alert("Funil clonado!");
    } catch (e) { alert(e.message); }
  }

  async function salvarEtapa() {
    try {
      if (!selectedFunil) { alert("Escolha um funil"); return; }
      const payload = {
        ...etapaForm,
        funil_id: selectedFunil,
        dias_apos: Number(etapaForm.dias_apos) || 0,
        ativo: Number(etapaForm.ativo) ? 1 : 0,
        tipo_midia: tipoMidiaEtapa || "",
        midia_url: arquivoUrlEtapa || ""
      };
      const r = await fetch(`${API_BASE}/funilwzp_etapas_crud.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Falha ao salvar etapa");
      alert("Etapa salva");

      await listarEtapas(selectedFunil);
      await listar({ preserveEtapas: true });

      setEtapaForm({ acao: "criar", etapa_id: 0, funil_id: 0, nome: "", mensagem: "", dias_apos: 0, ativo: 1 });
      setArquivoUrlEtapa("");
      setTipoMidiaEtapa("");
      setShowEmojiEtapa(false);
    } catch (e) { alert(e.message); }
  }
  async function excluirEtapa(id) {
    if (!window.confirm("Excluir esta etapa? (mova/ajuste os leads antes)")) return;
    try {
      const r = await fetch(`${API_BASE}/funilwzp_etapas_crud.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ acao: "excluir", funil_id: selectedFunil, etapa_id: id })
      });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Falha ao excluir etapa");

      await listarEtapas(selectedFunil);
      await listar({ preserveEtapas: true });
    } catch (e) { alert(e.message); }
  }
  async function salvarReordenacao() {
    try {
      const r = await fetch(`${API_BASE}/funilwzp_etapas_crud.php`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ acao: "reordenar", funil_id: selectedFunil, nova_ordem: etapasOrdemDraft })
      });
      const j = await safeJson(r);
      if (!j.ok) throw new Error(j.error || "Falha ao reordenar");
      alert("Ordem salva");

      await listarEtapas(selectedFunil);
      await listar({ preserveEtapas: true });
    } catch (e) { alert(e.message); }
  }

  return (
    <>
      {/* Título FORA do wrapper */}
      <div className="ncrmFnl-pageHeading">
        <h1 className="ncrmFnl-title">Funil de Mensagens</h1>
      </div>

      {/* Wrapper principal */}
      <div className="ncrmFnl-root">
        <div className="ncrmFnl-header">
          {/* Ações à direita */}
          <div className="ncrmFnl-actions">
            <button
              className="ncrmFnl-btn ncrmFnl-btnGhost ncrmFnl-btnSm ncrmFnl-btnManageFunis"
              onClick={() => { setShowFunilModal(true); setFunilForm({ acao: "criar", funil_id: 0, nome: "", descricao: "" }); }}
            >
              Gerenciar Funis
            </button>
            <button
              className="ncrmFnl-btn ncrmFnl-btnGhost ncrmFnl-btnSm ncrmFnl-btnEtapasFunil"
              onClick={() => setShowEtapasModal(true)}
            >
              Etapas do Funil
            </button>

            <button
              className="ncrmFnl-btn ncrmFnl-btnPrimary ncrmFnl-btnSm"
              onClick={() => setShowBulkModal(true)}
              disabled={!selectedFunil}
              title={!selectedFunil ? "Selecione um funil primeiro" : ""}
            >
              Adicionar em massa
            </button>

          </div>
        </div>

        {/* Filtros e topo */}
        <section className="ncrmFnl-card">
          <div className="ncrmFnl-filtersGrid">
            <div className="ncrmFnl-field ncrmFnl-fieldFunil">
              <label>Funil</label>
              <select value={selectedFunil} onChange={(e)=>{ setSelectedFunil(Number(e.target.value)); setPage(1); }}>
                <option value={0}>Selecionar…</option>
                {funis.map(f => (<option key={f.id} value={f.id}>{f.nome} {f.ativo ? '' : '(inativo)'}</option>))}
              </select>
            </div>
            <div className="ncrmFnl-field ncrmFnl-fieldStatus">
              <label>Status</label>
              <select value={statusFilter} onChange={(e)=>{ setStatusFilter(e.target.value); setPage(1); }}>
                <option value="">Todos</option>
                <option value="ativo">Ativo</option>
                <option value="pausado">Pausado</option>
                <option value="concluido">Concluído</option>
                <option value="removido">Removido</option>
              </select>
            </div>
            <div className="ncrmFnl-field ncrmFnl-fieldQuery">
              <label>Filtrar listagem (nome/telefone)</label>
              <input value={query} onChange={(e)=>{ setQuery(e.target.value); setPage(1); }} placeholder="Digite para filtrar…" />
            </div>
            <div className="ncrmFnl-field ncrmFnl-fieldPerPage">
              <label>Itens por página</label>
              <select value={perPage} onChange={(e)=>{ setPerPage(Number(e.target.value)); setPage(1); }}>
                {[10,20,30,50,100].map(n=> <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
          </div>

          <form onSubmit={handleAddLead} className="ncrmFnl-topForm">
            <div className="ncrmFnl-field ncrmFnl-fieldLead">
              <label>Lead</label>
              <LeadAutocomplete
                api={`${API_BASE}/getLeads.php`}
                value={leadIdForm}
                display={leadDisplay}
                onChange={(id, label) => { setLeadIdForm(id); setLeadDisplay(label); }}
              />
            </div>
            <div className="ncrmFnl-field ncrmFnl-fieldEtapaInicial">
              <label>Etapa inicial (opcional)</label>
              <select value={etapaIdForm} onChange={(e)=>setEtapaIdForm(Number(e.target.value))}>
                <option value={0}>Automática (1ª etapa)</option>
                {etapas.map(e => <option key={e.id} value={e.id}>{e.ordem}. {e.nome}</option>)}
              </select>
            </div>
            <div className="ncrmFnl-topFormActions">
              <button className="ncrmFnl-btn ncrmFnl-btnPrimary ncrmFnl-btnAddAoFunil" type="submit">Adicionar ao Funil</button>
            </div>
          </form>
        </section>

      {/* BOARD: Indicadores + Kanban (rolam juntos) */}
<div className="ncrmFnl-board">
  <div className="ncrmFnl-boardInner">
    {/* Indicadores */}
    {selectedFunil > 0 && (
      <section className="ncrmFnl-metricsGrid">
        {etapas.map((ep, idx) => {
          const r = resumoEtapa(ep.id);
          const altClass = idx % 2 === 0 ? "ncrmFnl-metricAltA" : "ncrmFnl-metricAltB";
          return (
            <div key={ep.id} className={`ncrmFnl-metricCard ${altClass}`}>
              <div className="ncrmFnl-metricTitle">{ep.ordem}. {ep.nome}</div>
              <div className="ncrmFnl-metricKpi">{r.soma}</div>
              <div className="ncrmFnl-metricTags">
                {Object.entries(r.statusCounts).map(([k,v]) => (
                  <span key={k} className="ncrmFnl-tag">{k}: {v}</span>
                ))}
              </div>
            </div>
          );
        })}
      </section>
    )}

    {/* Kanban */}
    <section className="ncrmFnl-kanban">
      {selectedFunil>0 && etapas.length>0 ? (
        etapas.map(col => (
          <div key={col.id} className="ncrmFnl-kanbanCol" onDragOver={onDragOver} onDrop={(e)=>onDrop(e, col.id)}>
            <div className="ncrmFnl-kanbanColTitle">{col.ordem}. {col.nome}</div>
            <div className="ncrmFnl-kanbanList">
              {items.filter(i => i.etapa_id === col.id).map(card => (
                <article key={card.funil_lead_id} draggable onDragStart={(e)=>onDragStart(e, card)} className="ncrmFnl-kanbanCard">
                  <div className="ncrmFnl-kanbanCardRow">
                    <div className="ncrmFnl-kanbanCardTitle">{card.lead_nome || '—'}</div>
                    <span className={`ncrmFnl-badge ${badgeClass(card.status)}`}>{card.status}</span>
                  </div>
                  <div className="ncrmFnl-kanbanCardSub">{card.lead_telefone}</div>
                  <div className="ncrmFnl-kanbanCardMeta">Próx. envio: {formatarDataBrasil(card.proximo_envio) || '—'}</div>
                  <div className="ncrmFnl-kanbanCardActions">
                    {card.status === 'ativo' ? (
                      <button onClick={()=>handlePauseResume(card,'pause')} className="ncrmFnl-btn ncrmFnl-btnXs ncrmFnl-btnPause">Pausar</button>
                    ) : card.status === 'pausado' ? (
                      <button onClick={()=>handlePauseResume(card,'resume')} className="ncrmFnl-btn ncrmFnl-btnXs ncrmFnl-btnRetomar">Retomar</button>
                    ) : null}
                    <button onClick={()=>handleRemove(card)} className="ncrmFnl-btn ncrmFnl-btnXs ncrmFnl-btnRemover">Remover</button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))
      ) : (
        <div className="ncrmFnl-hint">Selecione um funil para visualizar o kanban.</div>
      )}
    </section>
  </div>
</div>




        {/* Paginação */}
        <section className="ncrmFnl-pagination">
          <div className="ncrmFnl-paginationInfo">Total: {total}</div>
          <div className="ncrmFnl-paginationControls">
            <button disabled={page<=1} onClick={()=>setPage(p=>Math.max(1,p-1))} className="ncrmFnl-btn ncrmFnl-btnPagAnterior">Anterior</button>
            <div className="ncrmFnl-paginationPage">
              <span>{page}</span>
              <span className="ncrmFnl-slash">/</span>
              <span>{totalPages}</span>
            </div>
            <button disabled={page>=totalPages} onClick={()=>setPage(p=>Math.min(totalPages,p+1))} className="ncrmFnl-btn ncrmFnl-btnPagProxima">Próxima</button>
          </div>
        </section>
      </div>

      {/* MODAL FUNIS */}
      {showFunilModal && (
        <Modal onClose={()=>setShowFunilModal(false)} titleNode={<strong>Gerenciar Funis</strong>} showX>
          <div className="ncrmFnl-modalGrid">
            <div className="ncrmFnl-modalCol">
              <div className="ncrmFnl-field"><label>Ação</label>
                <select value={funilForm.acao} onChange={e=>setFunilForm(v=>({...v, acao:e.target.value}))}>
                  <option value="criar">Criar</option><option value="editar">Editar</option>
                </select>
              </div>
              {funilForm.acao === 'editar' && (
                <div className="ncrmFnl-field"><label>Funil alvo</label>
                  <select value={funilForm.funil_id} onChange={e=>{
                    const id = Number(e.target.value); const f = funis.find(x=>x.id===id);
                    setFunilForm(v=>({ ...v, funil_id:id, nome: f?.nome || v.nome, descricao: f?.descricao || v.descricao }));
                  }}>
                    <option value={0}>Selecionar…</option>
                    {funis.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                  </select>
                </div>
              )}
              <div className="ncrmFnl-field"><label>Nome</label>
                <input value={funilForm.nome} onChange={e=>setFunilForm(v=>({...v, nome:e.target.value}))} />
              </div>
              <div className="ncrmFnl-field"><label>Descrição</label>
                <textarea rows={4} value={funilForm.descricao} onChange={e=>setFunilForm(v=>({...v, descricao:e.target.value}))} />
              </div>
              <div className="ncrmFnl-modalActions">
                <button className="ncrmFnl-btn ncrmFnl-btnSm ncrmFnl-btnFunisCancelar" onClick={()=>setShowFunilModal(false)}>Cancelar</button>
                <button className="ncrmFnl-btn ncrmFnl-btnPrimary ncrmFnl-btnSm ncrmFnl-btnFunisSalvar" onClick={salvarFunil}>Salvar</button>
              </div>
            </div>

            <div className="ncrmFnl-modalCol">
              <div className="ncrmFnl-funisList">
                {funis.map(f => (
                  <div key={f.id} className="ncrmFnl-funilRow">
                    <div className="ncrmFnl-funilRowMain" onClick={()=>setSelectedFunil(f.id)}>
                      <div className="ncrmFnl-funilRowName">{f.nome}</div>
                      <div className="ncrmFnl-funilRowDesc">{f.descricao || "—"}</div>
                    </div>
                    <div className="ncrmFnl-funilRowActions">
                      <label className="ncrmFnl-switch ncrmFnl-switchLabel">
                        <input type="checkbox" checked={!!f.ativo} onChange={()=>funilToggle(f)} />
                        <span className="ncrmFnl-switchSlider" />
                      </label>
                      <button className="ncrmFnl-iconBtn ncrmFnl-btnFunilEditar" title="Editar" onClick={()=>funilEditar(f)}><IconPencil /></button>
                      <button className="ncrmFnl-iconBtn ncrmFnl-btnFunilClonar" title="Clonar" onClick={()=>funilClonar(f)}><IconCopy /></button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* ===== MODAL: Adicionar em massa ===== */}
{showBulkModal && (
  <Modal
    onClose={() => setShowBulkModal(false)}
    title="Adicionar em massa ao Funil"
    showX
  >
    {!selectedFunil ? (
      <div className="ncrmFnl-hint">Selecione um funil primeiro.</div>
    ) : (
      <>
        <div className="ncrmFnl-bulkGrid">
          {/* Seleção de TAGs */}
          <div className="ncrmFnl-field">
            <div className="ncrmFnl-rowBetween">
              <label>Selecionar TAGs</label>
              <div className="ncrmFnl-links">
                <button
                  type="button"
                  className="ncrmFnl-linkBtn"
                  onClick={() => setBulkSelectedTags(bulkTags.map(t => t.id))}
                >
                  Marcar todas
                </button>
                <span className="ncrmFnl-divider">•</span>
                <button
                  type="button"
                  className="ncrmFnl-linkBtn"
                  onClick={() => setBulkSelectedTags([])}
                >
                  Desmarcar todas
                </button>
              </div>
            </div>

            <div className="ncrmFnl-tagsChooser">
              {bulkTags.map(t => (
                  <label
                    key={t.id}
                    className={`ncrmFnl-chip ${bulkSelectedTags.includes(t.id) ? "isSelected" : ""}`}
                    style={{
                      "--tag-bg": t.cor || "#f3f4f6",
                      "--tag-border": t.cor || "transparent",
                      "--tag-fg": "#fff"
                    }}
                  >

                  <input
                    type="checkbox"
                    checked={bulkSelectedTags.includes(t.id)}
                    onChange={e =>
                      setBulkSelectedTags(prev =>
                        e.target.checked ? [...prev, t.id] : prev.filter(x => x !== t.id)
                      )
                    }
                  />
                  <span className="ncrmFnl-chipText">{t.nome}</span>
                  {Number.isFinite(t.count) && (
                    <small className="ncrmFnl-chipCount">({t.count})</small>
                  )}
                </label>

              ))}
            </div>

            {/* Alguma das / Todas as tags */}
            <div className="ncrmFnl-switchLine">
              <span
                className={`ncrmFnl-switchLabel ${bulkMatch === "any" ? "isActive" : ""}`}
                onClick={() => setBulkMatch("any")}
              >
                Alguma das
              </span>
              <label className="ncrmFnl-switch">
                <input
                  type="checkbox"
                  checked={bulkMatch === "all"}
                  onChange={e => setBulkMatch(e.target.checked ? "all" : "any")}
                />
                <span className="ncrmFnl-switchSlider" />
              </label>
              <span
                className={`ncrmFnl-switchLabel ${bulkMatch === "all" ? "isActive" : ""}`}
                onClick={() => setBulkMatch("all")}
              >
                Todas as tags
              </span>
            </div>
          </div>

          {/* Etapa inicial + somente fora do funil */}
          <div className="ncrmFnl-twoCols">
            <div className="ncrmFnl-field">
              <label>Etapa inicial (opcional)</label>
              <select value={bulkEtapa} onChange={e => setBulkEtapa(e.target.value)}>
                <option value={0}>Automática (1ª etapa)</option>
                {etapas.map(e => (
                  <option key={e.id} value={e.id}>
                    {e.ordem}. {e.nome}
                  </option>
                ))}
              </select>
            </div>

            <div className="ncrmFnl-field">
              <label>Somente leads fora do funil</label>
              <select
                value={bulkOnlyOut ? 1 : 0}
                onChange={e => setBulkOnlyOut(Number(e.target.value) === 1)}
              >
                <option value={1}>Sim</option>
                <option value={0}>Não (duplicados serão ignorados)</option>
              </select>
            </div>
          </div>

          {/* Filtros complementares */}
          <div className="ncrmFnl-twoCols">
            <div className="ncrmFnl-field">
              <label>Filtro (nome/telefone contém)</label>
              <input
                value={bulkQuery}
                onChange={e => setBulkQuery(e.target.value)}
                placeholder="Opcional"
              />
            </div>

            <div className="ncrmFnl-field">
              <label>Data de criação (de/até)</label>
              <div className="ncrmFnl-inline">
                <input
                  type="date"
                  value={
                    bulkCreatedFrom.includes("/") ? brToIso(bulkCreatedFrom) : bulkCreatedFrom
                  }
                  onChange={e => setBulkCreatedFrom(e.target.value)}
                />
                <span className="ncrmFnl-slash">—</span>
                <input
                  type="date"
                  value={bulkCreatedTo.includes("/") ? brToIso(bulkCreatedTo) : bulkCreatedTo}
                  onChange={e => setBulkCreatedTo(e.target.value)}
                />
              </div>
            </div>
          </div>


                   {/* Lista de leads da pré-visualização */}
        {bulkLeads.length > 0 && (
          <div className="ncrmFnl-card" style={{ marginTop: 10 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 8,
                flexWrap: "wrap"
              }}
            >
              <label className="ncrmFnl-switch">
                <input
                  type="checkbox"
                  checked={bulkSelectAllGlobal}
                  onChange={e => {
                    const v = e.target.checked;
                    setBulkSelectAllGlobal(v);
                    // mudou de modo? zera a estrutura que não será usada
                    if (v) setBulkChecked(new Set());
                    else   setBulkExcluded(new Set());
                  }}
                />

                <span className="ncrmFnl-switchSlider" />
              </label>
              <span>Selecionar todos leads</span>
              <span className="ncrmFnl-muted">Selecionados: {selectedCount}</span>
            </div>

            <div style={{ maxHeight: 300, overflow: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f9fafb" }}>
                    <th style={{ width: 44 }}></th>
                    <th style={{ textAlign: "left", padding: "8px" }}>Nome</th>
                    <th style={{ textAlign: "left", padding: "8px" }}>Telefone</th>
                  </tr>
                </thead>
                <tbody>
                  {bulkLeads.map(l => (
                    <tr key={l.id} style={{ borderTop: "1px solid #e5e7eb" }}>
                      <td style={{ textAlign: "center", padding: "6px" }}>
                        <input
                          type="checkbox"
                          // ❗ não desabilite quando global; usamos exceções
                          checked={bulkSelectAllGlobal ? !bulkExcluded.has(l.id) : bulkChecked.has(l.id)}
                          onChange={() => toggleOne(l.id)}
                        />

                      </td>
                      <td style={{ padding: "6px 8px" }}>{l.nome || "—"}</td>
                      <td style={{ padding: "6px 8px" }}>{l.telefone || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Paginação da prévia */}
            <div className="ncrmFnl-alignRight" style={{ gap: 8, marginTop: 8 }}>
              <button className="ncrmFnl-btn"
              onClick={() => { setBulkPage(p => Math.max(1, p - 1)); previewBulk(true); }}
              disabled={bulkPage <= 1}
            >◀</button>

            <button className="ncrmFnl-btn"
              onClick={() => { setBulkPage(p => p + 1); previewBulk(true); }}
              disabled={bulkLeads.length < bulkPerPage}
            >▶</button>

                        </div>
                      </div>
                    )}


          {/* Ações */}
          {bulkError && <div className="ncrmFnl-errorBox">{bulkError}</div>}
          <div className="ncrmFnl-alignRight ncrmFnl-gapSm">
            <button className="ncrmFnl-btn ncrmFnl-btnPreview" onClick={previewBulk} disabled={bulkLoading}>
              Listar Leads
            </button>
                        
            <button className="ncrmFnl-btn ncrmFnl-btnClear" onClick={clearBulkFilters} disabled={bulkLoading}>
              Limpar
            </button>

            <button
              className="ncrmFnl-btn ncrmFnl-btnConfirm"
              onClick={confirmBulk}
              disabled={bulkLoading || (!bulkSelectAllGlobal && selectedCount === 0)}
            >
              Confirmar inclusão
            </button>

          </div>
        </div>

       
                  </>
                )}
              </Modal>
            )}



      {/* MODAL ETAPAS */}
      {showEtapasModal && (
        <Modal
          onClose={()=>setShowEtapasModal(false)}
          titleNode={
            <span className="ncrmFnl-modalTitleWrap">
              <strong>Etapas do Funil</strong>
              {selectedFunil ? (
                <span className="ncrmFnl-modalFunilName"> — {funis.find(f => f.id === selectedFunil)?.nome || ""}</span>
              ) : null}
            </span>
          }
          showX
        >
          {selectedFunil ? (
            <div className="ncrmFnl-etapasGrid">
              <div>
                <h4 className="ncrmFnl-sectionTitle ncrmFnl-sectionTitlePb">Ordem das etapas</h4>
                <ol className="ncrmFnl-etapasList">
                  {etapas.map((e, idx) => (
                    <li key={e.id} className="ncrmFnl-etapaItem">
                      <div>
                        <div className="ncrmFnl-etapaNome">{idx+1}. {e.nome}</div>
                        <div className="ncrmFnl-etapaMeta">ID {e.id} • Dias após: {e.dias_apos}</div>
                      </div>
                      <div className="ncrmFnl-rowActions">
                        <button className="ncrmFnl-btn ncrmFnl-btnGhost ncrmFnl-btnXs ncrmFnl-btnEtapaUp" onClick={()=>moverEtapa(e.id, -1)}>↑</button>
                        <button className="ncrmFnl-btn ncrmFnl-btnGhost ncrmFnl-btnXs ncrmFnl-btnEtapaDown" onClick={()=>moverEtapa(e.id, +1)}>↓</button>
                        <button className="ncrmFnl-btn ncrmFnl-btnGhost ncrmFnl-btnXs ncrmFnl-btnEtapaEditar" onClick={()=>editarEtapaStart(e)}>Editar</button>
                        <button className="ncrmFnl-btn ncrmFnl-btnDanger ncrmFnl-btnXs ncrmFnl-btnEtapaExcluir" onClick={()=>excluirEtapa(e.id)}>Excluir</button>
                      </div>
                    </li>
                  ))}
                </ol>
                <div className="ncrmFnl-alignRight">
                  <button className="ncrmFnl-btn ncrmFnl-btnSalvarOrdem" onClick={salvarReordenacao}>Salvar ordem</button>
                </div>
              </div>

              <div>
                <h4 className="ncrmFnl-sectionTitle">{etapaForm.acao === 'editar' ? 'Editar Etapa' : 'Nova Etapa'}</h4>
                <div className="ncrmFnl-formGrid">
                  <div className="ncrmFnl-field"><label>Nome</label>
                    <input value={etapaForm.nome} onChange={e=>setEtapaForm(v=>({...v, nome:e.target.value}))} />
                  </div>
                  <div className="ncrmFnl-field">
  <label>Mensagem</label>

  <div style={{ position: "relative" }}>
    <textarea
      rows={6}
      value={etapaForm.mensagem}
      onChange={e => setEtapaForm(v => ({ ...v, mensagem: e.target.value }))}
      placeholder="Use variáveis: {{nome}}, {{primeiro_nome}}, {{data_hoje}}"
      style={{ width: "100%", boxSizing: "border-box", borderRadius: 8, padding: "12px 44px 12px 12px" }}
    />

    {/* Botão emoji */}
    <button
      type="button"
      onClick={() => setShowEmojiEtapa(prev => !prev)}
      style={{
        position: "absolute", bottom: 8, right: 8,
        background: "none", border: "none", fontSize: 20, lineHeight: 1, cursor: "pointer"
      }}
      aria-label="Inserir emoji"
    >
      😊
    </button>

    {showEmojiEtapa && (
      <div style={{ position: "absolute", top: "100%", right: 0, zIndex: 1000 }}>
        <EmojiPicker
          onEmojiClick={({ emoji }) => {
            setEtapaForm(v => ({ ...v, mensagem: (v.mensagem || "") + emoji }));
            setShowEmojiEtapa(false);
          }}
          autoFocusSearch={false}
          height={350}
          width={300}
          theme="light"
        />
      </div>
    )}
  </div>

  {/* Variáveis (mantém seu bloco existente) */}
  <div className="ncrmFnl-varButtons">
    <button type="button" className="ncrmFnl-btn ncrmFnl-btnGhost ncrmFnl-btnXs" onClick={() => appendVar("{{nome}}")}>{"{{nome}}"}</button>
    <button type="button" className="ncrmFnl-btn ncrmFnl-btnGhost ncrmFnl-btnXs" onClick={() => appendVar("{{primeiro_nome}}")}>{"{{primeiro_nome}}"}</button>
    <button type="button" className="ncrmFnl-btn ncrmFnl-btnGhost ncrmFnl-btnXs" onClick={() => appendVar("{{data_hoje}}")}>{"{{data_hoje}}"}</button>
  </div>

  {/* Upload de anexo */}
  <div className="ncrmFnl-field" style={{ marginTop: 10 }}>
    <label>Anexar arquivo (imagem, PDF, áudio, vídeo)</label>
   <input
        ref={fileEtapaRef}
        type="file"
        accept="image/*,.pdf,audio/*,video/*"
        onChange={async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const formData = new FormData();
        formData.append("arquivo", file);
        setUploadEtapaEmAndamento(true);
        try {
          const res = await fetch("/crm-wly/api/whatsapp/upload_temp.php", {
            method: "POST",
            body: formData,
            credentials: "include",
          });
          const data = await res.json();
          if (data.success) {
            setArquivoUrlEtapa(data.url);
            setTipoMidiaEtapa(data.tipo_midia || "");
            alert("Arquivo anexado à etapa.");
          } else {
            alert("Erro ao processar o arquivo: " + (data.message || ""));
          }
        } catch (err) {
          console.error(err);
          alert("Erro ao enviar arquivo.");
        } finally {
          setUploadEtapaEmAndamento(false);
        }
      }}
    />
    {uploadEtapaEmAndamento && <small>Enviando arquivo…</small>}

    {(arquivoUrlEtapa || tipoMidiaEtapa) && (
      <div style={{ marginTop: 6 }}>
        <small>Tipo: {tipoMidiaEtapa || "—"}</small><br />
        {arquivoUrlEtapa && (
          <a href={arquivoUrlEtapa} target="_blank" rel="noreferrer">
            Ver arquivo atual
          </a>
        )}<br />
        <button
          type="button"
          className="ncrmFnl-btnRemoverAnexo"
          onClick={() => { setArquivoUrlEtapa(""); setTipoMidiaEtapa(""); }}
        >
          Remover anexo
        </button>


      </div>
    )}

  </div>
</div>
 
                  <div className="ncrmFnl-twoCols">
                    <div className="ncrmFnl-field"><label>Dias após</label>
                      <input
                        type="number"
                        value={Number.isFinite(etapaForm.dias_apos) ? etapaForm.dias_apos : 0}
                        onChange={e=>setEtapaForm(v=>({...v, dias_apos:Number(e.target.value)}))}
                      />
                    </div>
                    <div className="ncrmFnl-field"><label>Ativa?</label>
                      <select value={etapaForm.ativo} onChange={e=>setEtapaForm(v=>({...v, ativo:Number(e.target.value)}))}>
                        <option value={1}>Sim</option><option value={0}>Não</option>
                      </select>
                    </div>
                  </div>
                  <div className="ncrmFnl-alignRight ncrmFnl-gapSm">
                    <button className="ncrmFnl-btn ncrmFnl-btnSm ncrmFnl-btnLimparEtapa" onClick={()=>resetEtapaForm()}>Limpar</button>
                    <button className="ncrmFnl-btn ncrmFnl-btnPrimary ncrmFnl-btnSm ncrmFnl-btnSalvarEtapa" onClick={salvarEtapa}>Salvar Etapa</button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="ncrmFnl-hint">Selecione um funil para gerenciar as etapas.</div>
          )}
        </Modal>
      )}

    </>
  );

  function moverEtapa(id, delta) {
    const idx = etapasOrdemDraft.indexOf(id); if (idx < 0) return;
    const arr = [...etapasOrdemDraft]; const novo = idx + delta; if (novo < 0 || novo >= arr.length) return;
    const [rem] = arr.splice(idx, 1); arr.splice(novo, 0, rem); setEtapasOrdemDraft(arr);
    const etapasOrdenadas = [...etapas].sort((a,b) => arr.indexOf(a.id) - arr.indexOf(b.id));
    setEtapas(etapasOrdenadas);
  }
  function editarEtapaStart(e) {
  setEtapaForm({
    acao: 'editar',
    etapa_id: e.id,
    funil_id: selectedFunil,
    nome: e.nome,
    mensagem: e.mensagem,
    dias_apos: (e.dias_apos ?? e.dias_após ?? 0),
    ativo: e.ativo
  });

  // 👇 Novo: refletir o anexo da etapa no formulário
  setTipoMidiaEtapa(e.tipo_midia || "");
  setArquivoUrlEtapa(e.midia_url || "");

  // 👇 Importante: limpar o <input type="file"> para não “herdar” seleção anterior
  if (fileEtapaRef.current) fileEtapaRef.current.value = "";
}

function resetEtapaForm() {
  setEtapaForm({ acao: 'criar', etapa_id: 0, funil_id: 0, nome: '', mensagem: '', dias_apos: 0, ativo: 1 });
  setArquivoUrlEtapa("");
  setTipoMidiaEtapa("");
  if (fileEtapaRef.current) fileEtapaRef.current.value = "";
}

}

// ======= Componentes auxiliares =======
function Modal({ titleNode, title, children, onClose, showX }) {
  useEffect(() => {
    function onEsc(e){ if(e.key === 'Escape') onClose?.(); }
    document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [onClose]);
  return (
    <div className="ncrmFnl-modalRoot">
      <div className="ncrmFnl-modalOverlay" onClick={onClose} />
      <div className="ncrmFnl-modalCard">
        <div className="ncrmFnl-modalHead">
          <h3 className="ncrmFnl-modalTitle">{titleNode ?? title}</h3>
          {showX ? (
            <button onClick={onClose} className="ncrmFnl-modalClose" aria-label="Fechar">✕</button>
          ) : (
            <button onClick={onClose} className="ncrmFnl-btn ncrmFnl-btnModalFechar">Fechar</button>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}

function LeadAutocomplete({ api, value, display, onChange }) {
  const [q, setQ] = useState("");
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);

  useEffect(() => { if (!q) { setOpts([]); return; } debounceFetch(q); return () => clearTimeout(timer.current); }, [q]);

  function debounceFetch(text) {
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        setLoading(true);
        const r = await fetch(`${api}?q=${encodeURIComponent(text)}&limit=10`, { credentials: "include" });
        const list = await r.json();
        setOpts(Array.isArray(list) ? list : []);
        setOpen(true);
      } catch (e) {
        setOpts([]); setOpen(false);
      } finally { setLoading(false); }
    }, 300);
  }

  function choose(opt) {
    onChange(String(opt.id), `${opt.nome} — ${opt.telefone}`);
    setOpen(false); setQ("");
  }

  return (
    <div className="ncrmFnl-autoComp">
      <input
        className="ncrmFnl-autoCompInput"
        value={display || ""}
        placeholder="Digite o nome/telefone e selecione…"
        onChange={e => { setQ(e.target.value); onChange("", e.target.value); }}
        onFocus={() => { if (opts.length) setOpen(true); }}
      />
      {loading && <div className="ncrmFnl-autoCompLoading">Buscando…</div>}
      {open && opts.length > 0 && (
        <div className="ncrmFnl-autoCompMenu">
          {opts.map(o => (
            <div key={o.id} className="ncrmFnl-autoCompItem" onClick={()=>choose(o)}>
              <div className="ncrmFnl-autoCompTitle">{o.nome}</div>
              <div className="ncrmFnl-autoCompSub">{o.telefone}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// helpers
async function safeJson(r) {
  const txt = await r.text();
  try { return JSON.parse(txt); } catch { return { ok:false, error:"Resposta inválida do servidor", raw: txt }; }
}
function upsertById(arr, item) {
  const idx = arr.findIndex(x => x.id === item.id);
  if (idx === -1) return [item, ...arr];
  const next = [...arr]; next[idx] = item; return next;
}
function badgeClass(status){
  switch(status){
    case 'ativo': return 'ncrmFnl-badgeGreen';
    case 'pausado': return 'ncrmFnl-badgeYellow';
    case 'concluido': return 'ncrmFnl-badgeBlue';
    case 'removido': return 'ncrmFnl-badgeRed';
    default: return 'ncrmFnl-badgeGray';
  }
}
